// API voor Instellingen (backend/apps/planning/api_settings.py): lezen mag iedereen, wijzigen alleen de superadmin;
// het logboek lezen de planners.
import { call } from "./api";
import type { LabelMeaning } from "./planning";

export interface ClosingDay { date: string; label: string }
export type DeadlineRight = "voorstel" | "direct" | "niet";
export type NotifyKey = "weekly" | "hours" | "dlToday" | "proposal" | "support";

/** Gelijk aan defaults() in backend/apps/planning/services/settings.py. */
export interface Settings {
  weekHours: number;
  /** ma tot zo */
  workdays: boolean[];
  closingDays: ClosingDay[];
  soonDays: number;
  lateDays: number;
  horizonWeeks: number;
  /** Capaciteit: vanaf vol oranje, boven overvol rood, onder ruimte blauw (in %) */
  full: number;
  over: number;
  room: number;
  /** labelnaam in kleine letters -> betekenis; een label dat er niet in staat, is actief werk */
  labels: Record<string, LabelMeaning>;
  /** Entra-object-id's */
  superadmins: string[];
  deadlineRight: DeadlineRight;
  ownTasks: boolean;
  pickUnowned: boolean;
  finishOthers: boolean;
  seeBoard: boolean;
  seeCapacity: boolean;
  excludeTemplate: boolean;
  snapshot: string;
  notify: Record<NotifyKey, boolean>;
  hoursMin: number;
  channel: "teams" | "mail" | "beide";
}

/** Alleen voor planners: wat het scherm toont maar niet wijzigt. */
export interface SettingsInfo {
  plannerGroup: string;
  /** Entra-object-id's van de plannersgroep */
  planners: string[];
  dataverse: string;
  refreshSeconds: number;
}

export interface SettingsResponse { settings: Settings; info?: SettingsInfo }

export interface AuditRow {
  id: number;
  at: string;
  userId: string;
  userName: string;
  action: string;
  target: string;
  /** bij settings.update: key, label, before, after en text ("Binnenkort: 7 naar 10 dagen") */
  details: { text?: string; [k: string]: unknown };
}

export const settingsApi = {
  get: () => call<SettingsResponse>("GET", "/api/settings"),
  save: (values: Partial<Settings>) => call<SettingsResponse & { ok: boolean; changed: (keyof Settings)[] }>("PUT", "/api/settings", values),
  audit: (limit = 20, actionPrefix?: string) =>
    call<AuditRow[]>("GET", "/api/audit?limit=" + limit + (actionPrefix ? "&action_prefix=" + encodeURIComponent(actionPrefix) : "")),
};
